export class CustomAgendaTask {
	public index;

	constructor(obj) {
		this.index = obj.index;
	}
} 
